var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-3",staticStyle:{"width":"100%","text-align":"-webkit-center"},attrs:{"id":"sms_received"}})}
var staticRenderFns = []

export { render, staticRenderFns }